import TabLayout from './proposals/TabLayout';
import ProposalsHeader from './proposals/ProposalsHeader';
import PostsListWrapper from './proposals/PostsListWrapper';

export default function BiddingPostProposalsTab() {
  return (
    <div
      className="bg-light-surface-primary dark:bg-dark-surface-primary rounded-[16px] border border-light-input-border dark:border-dark-input-border"
      data-testid="bidding-post-proposals-tab-container"
    >
      <TabLayout header={<ProposalsHeader />}>
        <PostsListWrapper />
      </TabLayout>
    </div>
  );
}
